/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { HelpDependencies } from './dependenciesHelpClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createHelp } from '../../factoriesAny.js';
export var helpDependencies = {
  HelpDependencies: HelpDependencies,
  typedDependencies: typedDependencies,
  createHelp: createHelp
};